import type { SelectorOption } from '../components/SearchableEntitySelector';
import { getEmployees } from '../services/employeeService';
import { getProjectAssignableEmployees } from '../services/projectService';
import { projectPersonName } from './projectForm';

/**
 * The employee's name is the option label; the employee number is only the
 * secondary line. The id stays employeeId for the API payload.
 */
export function employeeSelectorOption(item: {
  employeeId: number;
  employeeNumber: string | null;
  displayName: string | null;
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
}): SelectorOption {
  const number = item.employeeNumber?.trim() ?? '';
  const label = projectPersonName({
    displayName: item.displayName,
    employeeNumber: item.employeeNumber,
    firstName: item.firstName,
    middleName: item.middleName,
    lastName: item.lastName,
  });
  const hasName = label !== '' && label.toLowerCase() !== number.toLowerCase();
  return {
    id: item.employeeId,
    label: hasName ? label : number || 'Employee',
    subtitle: hasName && number ? number : undefined,
  };
}

/** HR Admin: any employee of the organization. */
export async function loadOrganizationEmployeeOptions(
  search: string,
): Promise<SelectorOption[]> {
  const result = await getEmployees({
    page: 1,
    pageSize: 20,
    filters: { search },
  });
  return result.items.map(employeeSelectorOption);
}

/** Team Lead: only the employees of the signed-in lead's teams (API-resolved). */
export async function loadTeamEmployeeOptions(
  search: string,
): Promise<SelectorOption[]> {
  const items = await getProjectAssignableEmployees(search);
  return items.map(employeeSelectorOption);
}
